// src/app/helpers/date-utils.ts
export class DateUtils {
  
  static formatDateForDisplay(date: string): string {
    const [year, month, day] = date.split('-');
    return `${month}/${day}/${year}`; // Format as MM/DD/YYYY for frontend display
  }
  
  static formatDateForBackend(date: string): string {
    const [month, day, year] = date.split('/');
    return `${year}-${month}-${day}`; // Convert back to YYYY-MM-DD for form control
  }

  static getCurrentFormattedDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    return `${month}/${day}/${year}`;
  } 
}
  